/* eslint-disable no-unused-vars */
import { Capacitor } from '@capacitor/core';

export default {
  async isApp() {
    return Capacitor.isNativePlatform();
  },
  platform: Capacitor.getPlatform(),
};
